import { initializeApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider, AppCheck } from 'firebase/app-check';

const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID
};

// Initialize Firebase App
export const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth: Auth = getAuth(firebaseApp);
export const db: Firestore = getFirestore(firebaseApp);

// Initialize Firebase App Check (client-side only)
let appCheckInstance: AppCheck | null = null;
if (typeof window !== 'undefined') { // Ensure this runs only on the client-side
    if (!process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY) {
        console.warn("NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not set. Firebase App Check will not be initialized.");
    } else {
        try {
            appCheckInstance = initializeAppCheck(firebaseApp, {
                provider: new ReCaptchaV3Provider(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!),
                isTokenAutoRefreshEnabled: true
            });
            console.log("Firebase App Check initialized successfully on the client.");
        } catch (e) {
            console.error("Error initializing Firebase App Check on the client:", e);
        }
    }
}

export const appCheck = appCheckInstance; // Export the AppCheck instance

export default firebaseApp; 